export default "__VITE_ASSET__DdKqtcOJ__"